import { ISystemReportDto, IUnifiedReportRequest } from 'src/generated-types/system-report-types'
import { useGet, usePost } from './reactQuery'

const baseUrl = () => 'report-generator'

export const endpoints = {
  getReports() {
    return `${baseUrl()}/reports`
  },
  generatePdf() {
    return `${baseUrl()}/generate-pdf`
  },
  generateExcel() {
    return `${baseUrl()}/generate-excel`
  },
}

export const useGetUnifiedReports = () => useGet<ISystemReportDto[]>(endpoints.getReports())

export const useGenerateUnifiedPdf = () =>
  usePost<IUnifiedReportRequest, object>(endpoints.generatePdf(), {}, { responseType: 'arraybuffer' })

export const useGenerateUnifiedExcel = () =>
  usePost<IUnifiedReportRequest, object>(endpoints.generateExcel(), {}, { responseType: 'arraybuffer' })
